import { styled } from "@mui/material";

import { makeStyles } from "@material-ui/core/styles";

export const backdropStyles = makeStyles({
  parent: {
    position: "relative",
    zIndex: 0,
    color: "white",
  },
  backdrop: {
    position: "absolute",
    color: "white",
  },
});

export const Row = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0%",
  width: "100%",
  marginTop: "2px",
  maxWidth: "400px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

export const SelectUserContainer = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "1%",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
  [theme.breakpoints.up("sm")]: {
    justifyContent: "flex-end",
  },
}));

export const ChatButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "0%",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
  [theme.breakpoints.up("sm")]: {
    justifyContent: "flex-start",
  },
}));


export const styles = {
  autoComplete: {
    width: "100%",
    margin: "auto",
    maxWidth: "300px",
  }as const
}